export const todoConstants = {
  TODO_ACTION_FAILED: 'TODO_ACTION_FAILED',
  TODO_ACTION_STARTED: 'TODO_ACTION_STARTED',
  CREATE_TODO_SUCCESS: 'CREATE_TODO_SUCCESS',
  UPDATING_TODO_SUCCESS: 'UPDATING_TODO_SUCCESS',
};
